import { render, staticRenderFns } from "./myBook.vue?vue&type=template&id=4b0f6cc6&scoped=true&"
import script from "./myBook.vue?vue&type=script&lang=js&"
export * from "./myBook.vue?vue&type=script&lang=js&"
import style0 from "./myBook.vue?vue&type=style&index=0&id=4b0f6cc6&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./myBook.vue?vue&type=style&index=1&id=4b0f6cc6&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style2 from "./myBook.vue?vue&type=style&index=2&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0f6cc6",
  null
  
)

export default component.exports